import React, { useEffect, useState } from "react";
import "../css/style.css";
import { Divider } from "@mui/material";
import { isSidebarCollapsed, toggleSidebarCollapsed } from "./Utils";
import { useAuth } from "../context/API_Client";
import { SideBarMenu } from "../reusableComponents/sideBarMenu/SideBarMenu";

const MenuBar = () => {
  const {
    merchantSettings,
    merchantLogo,
    merchantName,
    isSupportedRecon,
  } = useAuth();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(isSidebarCollapsed);
  const [mobileNavbar, setMobileNavbar] = useState(false);
  const [merchantData, setMerchantData] = useState();
  const [showRecon, setShowRecon] = useState(true);

  const checkSupportedRecon = async () => {
    const result = await isSupportedRecon();
    setShowRecon(result);
  };
  useEffect(() => {
    checkSupportedRecon();
  }, []);

  useEffect(() => {
    if (window.location.href.includes("/transactions")) {
      localStorage.removeItem("Orderfilters");
      localStorage.removeItem("OrderDate");
      localStorage.removeItem("OrderSearch");
    }
    if (window.location.href.includes("/payment_gateway_configurations")) {
      checkSupportedRecon();
    }
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width : 1000px)");
    setMobileNavbar(mediaQuery.matches);
    const updateShouldRenderMobileNavbar = (event) => {
      setMobileNavbar(mediaQuery.matches);
    };
    mediaQuery.addEventListener("change", updateShouldRenderMobileNavbar);

    merchantSettings((settings) => setMerchantData(settings));
  }, []);

  const handleSidebarToggle = () => {
    setSidebarCollapsed(!sidebarCollapsed);
    toggleSidebarCollapsed(!sidebarCollapsed);
  }
  const logoSrc =
    sidebarCollapsed && !mobileNavbar
      ? "/assets/boxpayLogoWithoutName.svg"
      : "/assets/boxpayLogoWithName.svg";

  const sidebarIconSrc = sidebarCollapsed
    ? "/assets/sidebarIcon.svg"
    : "/assets/sidebarIconOpposite.svg";

  return (
    <div>
      <aside className="main-sidebar sidebar-primary elevation-1 sidebar-no-expand">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#FAFAFA",
            height: "92px",
            width: "100%",
          }}
        >
          <div
            className="user-panel pt-4 pb-2 pl-2 d-flex "
            style={{ background: "#FAFAFA", height: "76px", width: "100%" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                gap: "8px",
              }}
            >
              <img
                src={
                  !merchantLogo || merchantLogo === ""
                    ? "/assets/cameraIcon.svg"
                    : merchantLogo
                }
                // className="img-circle elevation-2"
                // alt="User Image"
                style={{
                  height: "40px",
                  width: "40px",
                  marginLeft: "10px",
                  borderRadius: "50%",
                  marginTop: "3px",
                  border: "2px  solid white",
                  marginRight: sidebarCollapsed ? "0px" : "-15px",
                }}
              />
              {mobileNavbar && <div className="info">{merchantName}</div>}
              {sidebarCollapsed === false && mobileNavbar === false && (
                <div className="info">{merchantName}</div>
              )}
            </div>
          </div>

          <img
            data-widget="pushmenu"
            role="button"
            onClick={handleSidebarToggle}
            src={sidebarIconSrc}
            alt="sidebar"
            style={{
              display: mobileNavbar ? "none" : "flex",
              marginRight: sidebarCollapsed ? "-27px" : "-23px",
              marginTop: "16px",
            }}
          />
        </div>
        <Divider />
        <div className="sidebar" style={{ background: "#FAFAFA" }}>
          <nav className="mt-2">
            <SideBarMenu showRecon={showRecon} sidebarCollapsed={sidebarCollapsed} />
          </nav>
        </div>
      </aside>
    </div>
  );
};

export default MenuBar;
